export const TABLEAU_NAME = "tableau";
export const TABLEAU_DISPLAY_NAME = "Tableau";

export const BASE_URL_PREFIX = `/config/${TABLEAU_NAME}`;

export const TABLEAU_DEFAULT_PROJECT = "default";
